import {BASE_TRACK_API_URL} from "@constants/config";
import {apiRequestWithAuth} from "@helpers/query/apiRequestWithAuth";
import {OnShowError} from "@baseTypes/base";
import {
	CamerasDashboardResponse,
	CameraSnapshotsResponse,
	CamerasResponse,
	IBodyAddCamera,
	IBodyUpdateCamera,
	IPropsDeleteCamera,
	IPropsGetCameraLastSnap,
	IPropsGetCameras,
	IPropsGetCameraSnapsByTime
} from "@containers/cameras/types";
import {serialize} from "@helpers/query/serialize";
import moment from "moment-timezone";
import {DATE_FORMAT_CAMERAS} from "@containers/cameras/constants/dateFormat";

const BASE_URL_CAMERAS = `${BASE_TRACK_API_URL}/v1/accounts`

export const getCamerasListApi = async (
	{accountId, deviceId}: IPropsGetCameras,
	onError?: OnShowError
): Promise<CamerasResponse> => {
	const url = `${BASE_URL_CAMERAS}/${accountId}/cameras?` + serialize({
		...deviceId ? {deviceId} : {}
	})
	return await apiRequestWithAuth<CamerasResponse>({
		url,
		options: {
			method: "GET",
		},
		onError
	});
};


export const addCameraApi = async (
	{accountId, ...body}: IBodyAddCamera,
	onError?: OnShowError
) => {
	const url = `${BASE_URL_CAMERAS}/${accountId}/cameras/add?`
	return await apiRequestWithAuth({
		url,
		options: {
			method: "POST",
			body: JSON.stringify(body),
			headers: {
				'content-type': "application/json",
			}
		},
		onError
	});
};


export const updateCameraApi = async (
	{accountId, id, ...body}: IBodyUpdateCamera,
	onError?: OnShowError
) => {
	const url = `${BASE_URL_CAMERAS}/${accountId}/cameras/${id}/update`
	return await apiRequestWithAuth({
		url,
		options: {
			method: "PUT",
			body: JSON.stringify(body),
			headers: {
				'content-type': "application/json",
			}
		},
		onError
	});
};


export const deleteCameraApi = async (
	{accountId, id}: IPropsDeleteCamera,
	onError?: OnShowError
) => {
	const url = `${BASE_URL_CAMERAS}/${accountId}/cameras/delete/${id}`
	return await apiRequestWithAuth({
		url,
		options: {
			method: "PUT",
		},
		onError
	});
};


export const getCamerasDashboardApi = async (
	accountId: number,
	onError?: OnShowError
): Promise<CamerasDashboardResponse> => {
	const url = `${BASE_URL_CAMERAS}/${accountId}/cameras/dashboard`
	return await apiRequestWithAuth<CamerasDashboardResponse>({
		url,
		options: {method: 'GET'},
		onError
	})
}


export const getCameraSnapsByTimeApi = async (
	{
		accountId,
		deviceId,
		cameraNumber,
		dateTo,
		dateFrom,
	}: IPropsGetCameraSnapsByTime,
	onError?: OnShowError
): Promise<CameraSnapshotsResponse> => {
	
	const url = `${BASE_URL_CAMERAS}/${accountId}/cameras/devices/${deviceId}/snaps-by-time?` + serialize({
		...cameraNumber ? {cameraNumber} : {},
		dateTo: moment.tz(moment(dateTo, DATE_FORMAT_CAMERAS).format(), moment.tz.guess()).format(),
		dateFrom: moment.tz(moment(dateFrom, DATE_FORMAT_CAMERAS).format(), moment.tz.guess()).format(),
	})
	return await apiRequestWithAuth<CameraSnapshotsResponse>({
		url,
		options: {
			method: "GET",
		},
		onError
	});
};


export const getCameraLastSnapApi = async (
	{
		accountId,
		deviceId,
		cameraNumber,
	}: IPropsGetCameraLastSnap,
	onError?: OnShowError
): Promise<CameraSnapshotsResponse> => {
	
	const url = `${BASE_URL_CAMERAS}/${accountId}/cameras/devices/${deviceId}/last-snap?` + serialize({
		...cameraNumber ? {cameraNumber} : {},
	})
	return await apiRequestWithAuth<CameraSnapshotsResponse>({
		url,
		options: {
			method: "GET",
		},
		onError
	});
};

